export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5314.c674ea22.jpg";